import React from 'react'
import topFoldSVGReversed from './illustrations/topFoldSVGReversed.svg'

const About = () => {
  return (
    <section id="about">
      <div className="pb-10 md:flex md:flex-row-reverse md:pb-16 lg:pb-20 about-layout">
        <div className="px-4 md:w-1/2 md:justify-center md:flex md:flex-col">
          <div className="mb-6 md:mb-0 md:max-w-xl lg:pl-20">
            <h2 className="mb-4 heading">
              Elevata accuratezza di trascrizione vocale a partire da soli €0,07/min
            </h2>
            <p className="sub-heading">
              Quante volte ti capita di dimenticare dettagli importanti o una buona idea? Che si tratti di una riunione dove vengono dette molte cose, di una visita dal medico o di semplici idee creative, registra tutto con un memo vocale e salva come testo. Risparmia tempo. Risparmia denaro.
            </p>
          </div>
        </div>
        <div className="hidden md:w-1/2 md:block md:pr-10 img-container">
          <img
            width="663"
            height="404"
            src={topFoldSVGReversed}
            alt="About"
            className="about-img"
            decoding="async"
          />
        </div>
      </div>
    </section>
  )
}

export default About
